import S from 'constants/string.const';
import { SlickError } from 'errors/Slick.error';
import fromAnyToErrorMessage from 'utils/converters/any/fromAnyToErrorMessage.util';
import fromAnyToTrimmed from 'utils/converters/any/fromAnyToTrimmed.util';
import fromAnyToMessageV1 from 'utils/converters/backend/fromAnyToMessageV1.util';
import asObject from 'utils/objects/asObject.util';

export class BeCallError extends SlickError {
  constructor(options) {
    const isOldVersion = 4 !== options?.v;

    const message = isOldVersion ? fromAnyToMessageV1(options?.message ?? options?.cause?.message) : fromAnyToErrorMessage(options);

    super({ ...(options ?? {}), message });

    // different name value for legacy reasons
    if (isOldVersion) this.name = 'CallException';
  }
}

export class NoMainTokenError extends BeCallError {
  constructor() {
    super({
      message: 'No token saved!',
      code: 500,
      name: 'NoMainTokenError',
    });
  }
}

export class BeAbortError extends SlickError {
  constructor(options) {
    const { why, method, path, ...extra } = asObject(options);

    const reason = S.space + fromAnyToTrimmed(why) + S.space;

    super({
      ...extra,
      message: `Aborted ${reason} call for ${method} ${path}`,
      name: 'BeAbortError',
    });
  }
}

export class BeTimeoutError extends SlickError {
  constructor(options) {
    const { timeout, method, url, ...extra } = options ?? {};

    const n = timeout / 1000;
    const m = String(method);
    const u = String(url);

    super({
      ...extra,
      message: `Fetch timeout after ${n}s for ${m} ${u}`,
      name: 'BeTimeoutError',
    });
  }
}
